import React from 'react';
import FAQ from '../../components/FAQ';
import Layout from '../../components/Layout';
import Pricing from '../../components/Pricing';
import SEO from '../../components/SEO';
import * as P from '../../partials/GA06';

const GA06 = () => {
  return (
    <Layout>
      <P.Hero />
      <P.HowItWorks />
      <P.Features />
      <Pricing plans={P.plans} />
      <FAQ faq={P.faq} />
    </Layout>
  );
};

export default GA06;

export const Head = () => (
  <SEO
    title="Google Drive Auditor - Audit File Sharing in Google Drive and Shared Drives"
    description="Scan your Google Drive and know who else has access to your sensitive files and folders shared within or outside the organization."
  />
);
